import React from 'react';
import { Modal, Field, ModalFooter } from './modalComponents';  // Changé
import { fmtUSD } from './formatters';  // Changé

const DeliveryModal = ({ isOpen, onClose, deliveryForm, setDeliveryForm, inventory, onSave, saving }) => {
  if (!isOpen) return null;

  const setForm = (key, val) => setDeliveryForm(prev => ({ ...prev, [key]: val }));
  const total = deliveryForm.gallons && deliveryForm.price_per_gallon 
    ? parseFloat(deliveryForm.gallons) * parseFloat(deliveryForm.price_per_gallon) 
    : null;

  return (
    <Modal title="Log Supplier Delivery" onClose={onClose}>
      <div className="space-y-3">
        <Field label="Fuel type *">
          <select 
            value={deliveryForm.fuel_type} 
            onChange={e => setForm('fuel_type', e.target.value)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm"
          >
            {inventory.map(i => (
              <option key={i.fuel_type} value={i.fuel_type}>
                {i.tank_name || i.fuel_type}
              </option>
            ))}
          </select>
        </Field>
        
        <div className="grid grid-cols-2 gap-3">
          <Field label="Gallons received *">
            <input 
              type="number" 
              min="0" 
              placeholder="e.g. 5000"
              value={deliveryForm.gallons} 
              onChange={e => setForm('gallons', e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
            />
          </Field>
          <Field label="Cost / gallon *">
            <input 
              type="number" 
              min="0" 
              step="0.001" 
              placeholder="e.g. 4.25"
              value={deliveryForm.price_per_gallon} 
              onChange={e => setForm('price_per_gallon', e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
            />
          </Field>
        </div>

        {total !== null && (
          <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-3 text-sm">
            <span className="text-gray-400">Total delivery cost: </span>
            <span className="text-green-400 font-bold">{fmtUSD(total)}</span>
          </div>
        )}

        <Field label="Supplier name">
          <input 
            type="text" 
            placeholder="e.g. Avfuel Corp"
            value={deliveryForm.supplier_name} 
            onChange={e => setForm('supplier_name', e.target.value)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
          />
        </Field>
        
        <Field label="Invoice number">
          <input 
            type="text" 
            value={deliveryForm.invoice_number}
            onChange={e => setForm('invoice_number', e.target.value)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
          />
        </Field>
      </div>
      <ModalFooter 
        onCancel={onClose} 
        onSave={onSave}
        saving={saving} 
        disabled={!deliveryForm.gallons || !deliveryForm.price_per_gallon} 
        label="Save Delivery" 
      />
    </Modal>
  );
};

export default DeliveryModal;